<template>
  <transition>
    <div v-show="visible" :class="{'tips':true, bg:bg}" @click="close">
      <div v-html="message"></div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      message: "",
      duration: 3000,
      closed: false,
      timer: null,
      bg: true
    };
  },

  computed: {},

  watch: {
    closed(newVal) {
      if (newVal) {
        this.visible = false;
        this.destroyElement();
      }
    }
  },

  methods: {
    destroyElement() {
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    },

    close() {
      this.closed = true;
    },

    clearTimer() {
      clearTimeout(this.timer);
    },

    startTimer() {
      if (this.duration > 0) {
        this.timer = setTimeout(() => {
          if (!this.closed) {
            this.close();
          }
        }, this.duration);
      }
    }
  },

  mounted() {
    this.startTimer();
  }
};
</script>
<style lang="scss" scoped>
.tips {
  &.bg {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 100000;
    background-color: rgba(27, 28, 32, 0.2);
  }
  div {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 65%;
    background-color: rgba(27, 28, 32, 0.8);
    border-radius: 10px;
    padding: 20px;
    color: white;
    text-align: center;
    transform: translate(-50%, -50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tips/main.vue